import { render, staticRenderFns } from "./AcctPolicyHelpList2.vue?vue&type=template&id=354c2c26&"
import script from "./AcctPolicyHelpList2.vue?vue&type=script&lang=js&"
export * from "./AcctPolicyHelpList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports